import React, { useEffect, lazy, Suspense } from "react";
import { ConfigProvider, theme as antTheme, Spin } from "antd";
import { BrowserRouter, Route, Routes, useNavigate } from "react-router-dom";
import { getCookie } from "./utilities/utll";
import { useThemeStore } from "./store/useThemeStore";

const LoginPage = lazy(() => import("./Pages/Login"));
const Home      = lazy(() => import("./Pages/PostLogin"));

const PageLoader = () => (
  <div style={{ height: "100vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
    <Spin size="large" />
  </div>
);

function AppRoutes() {
  const navigate = useNavigate();
  useEffect(() => {
    const isLoggedIn = getCookie("auth");
    if (isLoggedIn) navigate("/postlogin");
    else navigate("/login");
  }, [navigate]);

  return (
    <Suspense fallback={<PageLoader />}>
      <Routes>
        <Route path="/"          element={<LoginPage />} />
        <Route path="/login"     element={<LoginPage />} />
        <Route path="/postlogin" element={<Home />} />
      </Routes>
    </Suspense>
  );
}

export default function App() {
  const { themeColor, isDark } = useThemeStore();

  return (
    <ConfigProvider
      theme={{
        algorithm: isDark ? antTheme.darkAlgorithm : antTheme.defaultAlgorithm,
        token: {
          colorPrimary: themeColor,
          colorLink:    themeColor,
        },
      }}
    >
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </ConfigProvider>
  );
}
